import firebase from "firebase";

// Initialize Firebase
const config = {
  databaseURL: "https://casos-clinicos-gastroin.firebaseio.com",
  apiKey: "AIzaSyCf-OtCdodecc9zsomtAfW7N-2NVDShtAU",
  authDomain: "casos-clinicos-gastroin.firebaseapp.com",
  projectId: "casos-clinicos-gastroin",
  storageBucket: "casos-clinicos-gastroin.firebasestorage.app",
  messagingSenderId: "546521559209",
  appId: "1:546521559209:web:dbe6f4e466f3712e25b9b8",
  measurementId: "G-XMNT0G4CJC"
};
firebase.initializeApp(config);
firebase.auth().languageCode = 'es'
const auth = firebase.auth();
const functions = firebase.functions();

const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
const facebookAuthProvider = new firebase.auth.FacebookAuthProvider();
const githubAuthProvider = new firebase.auth.GithubAuthProvider();
const twitterAuthProvider = new firebase.auth.TwitterAuthProvider();
const storage = firebase.storage();

const database = firebase.firestore();

export {
  database,
  storage,
  auth,
  functions,
  googleAuthProvider,
  githubAuthProvider,
  facebookAuthProvider,
  twitterAuthProvider
};
